import { gql } from "@apollo/client";

export const GET_LOST_DEMAND = gql`
  query GetLostDemand($startDate: String, $endDate: String) {
    getLostDemand(startDate: $startDate, endDate: $endDate) {
      status
      message
      data {
        range {
          startDate
          endDate
        }
        bookWindowHours
        summary {
          searches
          booked
          recovered
          lostNoSlots
          lostPartlyFull
          lostError
          notBooked
          lostValue
        }
        byDay {
          day
          searches
          booked
          lost
          lostValue
        }
        wantedDates {
          wantedDate
          searches
          lost
          female
        }
        areas {
          lat
          lng
          lost
          lostValue
          sampleAddress
        }
        services {
          serviceName
          lost
        }
        searches {
          who
          userId
          customerName
          phone
          searchDay
          firstAt
          outcome
          datesTried
          emptyDates
          female
          address
          cartValue
          serviceNames
        }
      }
    }
  }
`;
